<app-header>
  <div title>{{ 'meteringpoint.create.title' | translate }}</div>
</app-header>

<div class="p-6">
  <form [formGroup]="form">
    <app-guide-card [valid]="form.get('templateId')?.valid">
      <div title>{{ 'meteringPoint.create.template.title' | translate }}</div>
      <div description>{{ 'meteringPoint.create.template.description' | translate }}</div>
      <div>
        <app-input-group>
          <label appLabel>{{ 'meteringPoint.create.template.title' | translate }}</label>
          <select appSelect [collection]="templateList" formControlName="templateId" [autofocus]="true"></select>
        </app-input-group>
      </div>
    </app-guide-card>


    <!--- Målepunktsdetaljer --->
    <app-guide-card
      [valid]="form.get('detailCharacteristics.meteringPointType')?.valid && form.get('detailCharacteristics.subType')?.valid"
    >
      <div title>{{ 'meteringPoint.create.meteringPointDetails.title' | translate }}</div>
      <div description>{{ 'meteringPoint.create.meteringPointDetails.description' | translate }}</div>
      <div>
        <fieldset formGroupName="detailCharacteristics">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.create.meteringPointType' | translate }}</label>
            <select appSelect [collection]="meteringPointTypeList" [sortByTranslation]="true" formControlName="meteringPointType"></select>
          </app-input-group>

          <app-input-group>
            <label appLabel>{{ 'meteringPoint.create.meteringPointSubType' | translate }}</label>
            <select appSelect [collection]="meteringPointSubtypeList" [sortByTranslation]="true" formControlName="subType"></select>
          </app-input-group>
        </fieldset>

        <!-- Production MeteringPoint can manually add the MeteringPointId -->
        @if (form.get('detailCharacteristics.meteringPointType')?.value === MeteringPointType.Production ||
        form.get('detailCharacteristics.meteringPointType')?.value === MeteringPointType.OwnProduction ||
        form.get('detailCharacteristics.meteringPointType')?.value === MeteringPointType.VEProduction ||
        form.get('detailCharacteristics.meteringPointType')?.value === MeteringPointType.OtherProduction ||
        form.get('detailCharacteristics.meteringPointType')?.value === MeteringPointType.NetProduction ||
        form.get('detailCharacteristics.meteringPointType')?.value === MeteringPointType.SurplusProductionGroup
          ) {
          <div class="bg-slate-100 dark:bg-dark-border w-full h-[1px] mt-6 mb-4"></div>

          <app-input-group>
            <label appLabel>{{ 'meteringPoint.create.meteringPointId' | translate }}</label>
            <input appInput inputmode="numeric" pattern="[0-9]*" formControlName="identification" [placeholder]="'meteringPoint.create.meteringPointId' | translate">
          </app-input-group>
        }

      </div>
    </app-guide-card>

    <div class="duration-100 ease-in-out" [ngClass]="[ form.get('detailCharacteristics.meteringPointType')?.valid ? 'animate-fadein' : 'hidden']">
      <!--- Child MeteringPoint -->
      @if (form.get('parentMeteringPointIdentification')?.enabled) {
        <app-guide-card [valid]="form.get('parentMeteringPointIdentification')?.valid">
          <div title>{{ 'meteringPoint.create.child.title' | translate }}</div>
          <div description>{{ 'meteringPoint.create.child.description' | translate }}</div>
          <div>

            <app-input-group>
              <label appLabel>{{ 'meter.createform.parentid' | translate }}</label>
              <input appInput inputmode="numeric" pattern="[0-9]*"
                     formControlName="parentMeteringPointIdentification"
                     [placeholder]="'meter.createform.parentid' | translate"
                     [append]="'common.search' | translate"
                     (appendClick)="openMeteringPointModal()"
              >
            </app-input-group>
          </div>
        </app-guide-card>
      }

      <!--- Oprettelsesdetaljer --->
      <app-meteringpoint-form-creation-details [fullWidth]="false" [form]="form"></app-meteringpoint-form-creation-details>

      <!--- Udveksling --->
      @if (form.get('detailCharacteristics.meteringPointType')?.value === MeteringPointType.Exchange) {
        <app-meteringpoint-form-exchange [fullWidth]="false" [form]="form"></app-meteringpoint-form-exchange>
      }

      <!--- Installationsdetaljer --->
      <app-meteringpoint-form-installation [fullWidth]="false" [form]="form"></app-meteringpoint-form-installation>

      <!--- Aflæsning og afregning --->
      <app-meteringpoint-form-reading-billing [fullWidth]="false" [form]="form"></app-meteringpoint-form-reading-billing>

      <!--- Egenproduktion --->
      <app-meteringpoint-form-production [fullWidth]="false" [form]="form"></app-meteringpoint-form-production>

      <!--- Måler og detaljer --->
      @if (form.get('detailCharacteristics.subType')?.value === MeteringPointSubType.Physical) {
        <app-meteringpoint-form-meter [fullWidth]="false" [form]="form"></app-meteringpoint-form-meter>
      }

      <!--- Tilslutningspunkt --->
      <!--- Only Applicable to E17 / E18 / E20 --->
      @if (form.get('detailCharacteristics.meteringPointType')?.value === MeteringPointType.Consumption || form.get('detailCharacteristics.meteringPointType')?.value === MeteringPointType.Production
      || form.get('detailCharacteristics.meteringPointType')?.value === MeteringPointType.Exchange) {
        <app-guide-card
          [valid]="form.get('connectionPointId')?.valid"
        >
          <div title>
            {{ 'meteringPoint.create.connectionPoint.title' | translate }}
          </div>
          <div description>
            {{ 'meteringPoint.create.connectionPoint.description' | translate }}
          </div>
          <div>
            <app-input-group>
              <label appLabel>{{ 'meter.createform.connectionpointidentification' | translate }}</label>
              <input
                appInput
                formControlName="connectionPointIdentification"
                [placeholder]="'meter.createform.connectionpointidentification' | translate"
                [append]="'common.search' | translate"
                (appendClick)="openConnectionPointSearchModal()"
              >
            </app-input-group>

            <app-input-group>
              <label appLabel>{{ 'meter.createform.connectionpointaddress' | translate }}</label>
              <input appInput formControlName="connectionPointAddress" readonly [placeholder]="'meter.createform.connectionpointaddress' | translate">
            </app-input-group>
          </div>
          <div [formGroup]="form">
            <div formGroupName="detailCharacteristics">
              <app-input-group>
                <label appLabel>{{ 'meter.createform.comments' | translate }}</label>
                <input appInput formControlName="locationDescription">
              </app-input-group>
            </div>
          </div>
        </app-guide-card>
      } @else {
        @if (!childMeteringPoint) {
          <!-- Address - Applicable to everyone else -->
          <app-meteringpoint-form-address [fullWidth]="false" [form]="form"></app-meteringpoint-form-address>
        }
      }

      <div class="flex gap-4">
        <div class="w-1/5"></div>
        <div class="w-2/5">
          <app-card>
            <div class="flex justify-between">
              <div>
                <button
                  appButton
                  type="tertiary"
                  (click)="cancel()">{{ 'common.cancel' | translate }}</button>
              </div>
              <div>
                <button
                  appButton
                  (click)="create()"
                >{{ 'common.create' | translate }}</button>
              </div>
            </div>
          </app-card>
        </div>
      </div>
    </div>
  </form>
</div>

